/* Built In Imports */
import NextLink from 'next/link';
import React from 'react';

/* External Imports */
import { Box, Image, Link, Text, useDisclosure } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import BtnTryForFree from '@landing_pages/SadhguruExclusive/BtnTryForFree';
/* Services */

/**
 * Renders the BannerContent component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} BannerContent component
 */

const BannerContent = ({ sectionContent, region, language, PackageData }) => {
  const {
    isOpen: isFirstModalOpen,
    onOpen: onFirstModalOpen,
    onClose: onFirstModalClose,
  } = useDisclosure();
  const bannerDetail = sectionContent.body?.find(
    el => el.sectionId == 'HeaderBanner'
  );
  const bannerData = bannerDetail?.sectionContent;
  // console.log('data', bannerData);

  return <>
    <Box w={{ base: 'unset', lg: '1200px' }} m="0 auto" pos="relative">
      <Box
        pos="absolute"
        right="16px"
        top={{ base: '18px', lg: '36px' }}
        color="#121212"
        background="#FFBD31"
        borderRadius="100px"
        fontSize={{ base: '12px', md: '16px' }}
        fontWeight="500"
        minwidth={{ base: '66px', md: '106px' }}
        minH={{ base: '26px', md: '42px' }}
        textAlign="center"
        fontFamily="FedraSansStd-medium"
      >
        <NextLink href={refineUrlDomain(bannerData[5]?.linkUrl)} passHref legacyBehavior>
          <Link
            padding={{ base: '7px 20px', md: '20px' }}
            position="relative"
            top={{ base: '4px', md: '8px' }}
          >
            {bannerData[5]?.buttonText}
          </Link>
        </NextLink>
      </Box>
    </Box>
    <Image
      src={bannerData[4]?.image?.url}
      alt={bannerData[4]?.image?.alt}
      title={bannerData[4]?.image?.title}
      display={{ base: 'none !important', lg: 'block !important' }}
      w="100%"
    />
    <Image
      src={bannerData[4]?.mobileImage?.url}
      alt={bannerData[4]?.mobileImage?.alt}
      title={bannerData[4]?.mobileImage?.title}
      display={{ base: 'block !important', lg: 'none !important' }}
      w="100%"
    />
    <Box
      background="#121212"
      padding={{ base: '37px 16px', md: '77px 120px 0px 120px' }}
      w={{ base: 'auto', lg: '1000px', '2xl': '1400px' }}
      position="relative"
      mt={{ base: '-70px', lg: '-230px' }}
      left={{
        base: '0',
        lg: 'calc((100% - 1000px) / 2)',
        '2xl': 'calc((100% - 1400px) / 2)',
      }}
      textAlign="center"
      className="banner_content"
    >
      <Image
        src={`${config.imgPath}/d/46272/1645443786-sgx-logo.png`}
        pos="absolute"
        left={{
          base: 'calc((100% - 143px) / 2)',
          lg: 'calc((100% - 182px) / 2)',
        }}
        title="logo"
        alt="logo"
        top={{
          base: '-15%',
          sm: '-15%',
          md: '-15%',
          xl: '-15%',
          '2xl': '-15%',
        }}
        w={{ base: '142px', lg: 'auto' }}
        // mt={{ base: '162px', md: '169px' }}
        zIndex="100"
      />
      <Box
        as="h1"
        m={{ base: '0 auto' }}
        w={{ base: '287px', md: '570px', lg: '760px' }}
      >
        <Text
          color="#FFFFFF"
          fontSize={{ base: '22px', lg: '50px' }}
          lineHeight="1.29"
          fontFamily="FedraSansStd-A-medium"
          margin="0 0 20px 0"
        >
          {bannerData[0]?.titleText}
        </Text>
      </Box>
      <Text
        color="#D0CABA"
        fontSize={{ base: '16px', lg: '22px' }}
        lineHeight="30px"
        margin={{ base: '20px auto 10px auto' }}
        maxW={{ base: '270px', lg: 'unset' }}
        fontFamily="FedraSansStd-book"
      >
        {bannerData[0]?.titleSubtext}
      </Text>
      <Text
        color="#d0caba"
        fontSize={{ lg: '14px', base: '16px' }}
        fontFamily="FedraSansStd-book"
      >
        {bannerData[1]?.text}
      </Text>
      <Box
        m={{ base: '20px auto 20px auto', md: '50px auto 20px auto' }}
        display="block"
      >
        <BtnTryForFree
          sectionContent={bannerData[1]}
          region={region}
          language={language}
          PackageData={PackageData}
          eventname="sgx_try_free1_click"
        />
      </Box>
      <Box p={{ base: '0 20px', md: 'unset' }}>
        <Text
          fontSize={{ base: '18px', lg: '22px' }}
          fontFamily="FedraSansStd-book"
          color="#FFBD31"
          margin={{ base: '49px auto 0 auto', md: '49px 0 0 0' }}
          padding={{ base: '0 10px', md: '0' }}
          className="loginlink"
          maxW={{ base: '270px', md: '100%' }}
        >
          {bannerData[6]?.text}
          {/* {PackageData[0]?.currency != 'INR'
            ? PackageData[0]?.currency
            : 'Rs.'} */}
          {PackageData[0]?.currency}{' '}
          <Box as="span" textDecoration="line-through">
            {PackageData[0]?.package_projected_price}
          </Box>{' '}
          {PackageData[0]?.package_amount} {bannerData[7]?.text}
        </Text>
      </Box>
      <Text pt="25px" fontSize={{ base: '20px', md: '24px' }} color="#ffffff">
        {bannerData[8]?.text}
      </Text>
    </Box>
  </>;
};

export default BannerContent;
